import React from 'react';
import delve from 'dlv';
import metrics from 'maps/metrics';
import { Flex } from 'components/Overview/KPIs/shared.style';
import DownloadPerformanceKPIs from '../shared/KPIsData';
import { Grid } from 'components/Overview/Container/shared.style';
import { IDownloadKPIsProps } from './types';

const DownloadKPIs: React.FC<IDownloadKPIsProps> = (props) => {
  const { sortByMetric, kpis = {}, entityType, isPending } = props;
  const rtdMetric = metrics['count_rtd'];

  const albumValue = delve(kpis, ['album_data', sortByMetric.value], null);
  const albumChange = delve(
    kpis,
    ['album_data', sortByMetric?.change as string],
    null
  );
  const trackValue = delve(kpis, ['track_data', sortByMetric.value], null);
  const trackChange = delve(
    kpis,
    ['track_data', sortByMetric?.change as string],
    null
  );
  const albumRtdValue = delve(kpis, ['album_data', rtdMetric.value], null);
  const trackRtdValue = delve(kpis, ['track_data', rtdMetric.value], null);

  switch (entityType) {
    case 'release':
      return (
        <Flex>
          <DownloadPerformanceKPIs
            title={sortByMetric.label}
            value={albumValue}
            change={albumChange}
            isPending={isPending}
            rtdValue={albumRtdValue}
          />
        </Flex>
      );
    case 'track':
      return (
        <Flex>
          <DownloadPerformanceKPIs
            title={sortByMetric.label}
            value={trackValue}
            change={trackChange}
            isPending={isPending}
            rtdValue={trackRtdValue}
          />
        </Flex>
      );
    default:
      return (
        <Grid>
          <section>
            <h4>Tracks</h4>
            <DownloadPerformanceKPIs
              title={sortByMetric.label}
              value={trackValue}
              change={trackChange}
              isPending={isPending}
              rtdValue={trackRtdValue}
            />
          </section>
          <section>
            <h4>Releases</h4>
            <DownloadPerformanceKPIs
              title={sortByMetric.label}
              value={albumValue}
              change={albumChange}
              isPending={isPending}
              rtdValue={albumRtdValue}
            />
          </section>
        </Grid>
      );
  }
};

export default DownloadKPIs;
